const FuzzyReaction = require('../bootstrap').FuzzyReaction;
const AppDispatcher = FuzzyReaction.Dispatcher;
const AppActionConstants = require('../constants/AppActionConstants');

const ActionTypes = AppActionConstants.ActionTypes.casts;

module.exports = {
	storeCast: function(cast) {
		AppDispatcher.dispatch({
			type: ActionTypes.STORE_CAST,
			data: cast
		});
	},

	clearStoredCast: function() {
		AppDispatcher.dispatch({
			type: ActionTypes.CLEAR_STORED_CAST
		});
	}
};
